var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2407 4.64812C12.1667 5.57405 12.6296 6.69133 12.6296 7.99997C12.6296 9.30861 12.1667 10.4259 11.2407 11.3518C10.3148 12.2778 9.19753 12.7407 7.88889 12.7407C6.58025 12.7407 5.46914 12.2716 4.55556 11.3333L7.88889 7.99997V3.25923C9.19753 3.25923 10.3148 3.7222 11.2407 4.64812ZM7.90741 0.111084C10.0926 0.111084 11.9568 0.882689 13.5 2.4259C15.0432 3.96911 15.8148 5.82713 15.8148 7.99997C15.8148 10.1728 15.0432 12.0308 13.5 13.574C11.9568 15.1173 10.0926 15.8889 7.90741 15.8889C5.72222 15.8889 3.85802 15.1173 2.31481 13.574C0.771605 12.0308 0 10.1728 0 7.99997C0 5.82713 0.771605 3.96911 2.31481 2.4259C3.85802 0.882689 5.72222 0.111084 7.90741 0.111084ZM7.90741 14.3333C9.64815 14.3333 11.1358 13.716 12.3704 12.4815C13.6049 11.2469 14.2222 9.75306 14.2222 7.99997C14.2222 6.24689 13.6049 4.75306 12.3704 3.51849C11.1358 2.28392 9.64815 1.66664 7.90741 1.66664C6.16667 1.66664 4.67901 2.28392 3.44444 3.51849C2.20988 4.75306 1.59259 6.24689 1.59259 7.99997C1.59259 9.75306 2.20988 11.2469 3.44444 12.4815C4.67901 13.716 6.16667 14.3333 7.90741 14.3333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.f9c78d1e65cbf9502bf267ce25e55300.svg";
export { ForwardRef as ReactComponent };